import { deviceLinkLocalhostRoot, IsSuccessResult, faroFetch } from "./Devices";

enum SettingDateFormat {
    MonthFirst = 0,
    DayFirst = 1,
}

enum SettingUnit {
    mgd_L = 0,
    mmol_L = 1,
}

enum SettingHoursFormat {
    Hour12 = 0,
    Hour24 = 1,
}

interface DateTimeResult {
    dateTime: string;
}

interface DeviceSettings {
    monitorId: string;
    monitorBoardId: string;
    type: number;
    settingDateFormat: SettingDateFormat;
    settingGluUnit: SettingUnit;
    settingKetUnit: SettingUnit;
    settingsHoursFormat: SettingHoursFormat;
    settingsBepp: boolean;
    softwareVersion: string;
    settingsReserve: boolean;
}

export interface BloodGlucoseResult {
    testName: string;
    resultValue: string;
    unit: string;
    flags: number;
    testTime: string;
}

export const ApiConfigureDateTime = (deviceId: string, dateTime: string): Promise<IsSuccessResult> => {
    return faroFetch(`${deviceLinkLocalhostRoot}/devices/${deviceId}/ConfigureDateTime`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
        body: JSON.stringify({
            DateTime: dateTime,
        }),
    })
        .then(response => response.json())
}

export const ApiGetDateTime = (deviceId: string): Promise<DateTimeResult> => {
    return faroFetch(`${deviceLinkLocalhostRoot}/devices/${deviceId}/GetDateTime`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(response => response.json())
}

export const ApiConfigureSettings = (deviceId: string): Promise<IsSuccessResult> => {
    return faroFetch(`${deviceLinkLocalhostRoot}/devices/${deviceId}/ConfigureSettings`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(response => response.json())
}

export const ApiGetSettings = (deviceId: string): Promise<DeviceSettings> => {
    return faroFetch(`${deviceLinkLocalhostRoot}/devices/${deviceId}/GetSettings`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(response => response.json())
}

export const ApiClearResults = (deviceId: string): Promise<IsSuccessResult> => {
    return faroFetch(`${deviceLinkLocalhostRoot}/devices/${deviceId}/ClearResults`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(response => response.json())
}

export const ApiGetResults = (deviceId: string): Promise<Array<BloodGlucoseResult>> => {
    return faroFetch(`${deviceLinkLocalhostRoot}/devices/${deviceId}/GetResults`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(response => {
            if (!response.ok) throw Error(response.statusText);
            return response.json()
        });
}
